import { getRandomTwoDigitNumber } from "../../utils/helpers";
import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;
const WpApiUrl: string = `${hostname}/wp_api/v1`;

function getPageContent(
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    oauthTokenHeader
  );
}

function getSiteCurrentWidgets(siteUid: string, oauthTokenHeader: string) {
  return fetchWrapper.get(`${WpApiUrl}/widgets/${siteUid}/`, oauthTokenHeader);
}

function getSiteAllAvailableWidgets(
  siteUid: string | undefined,
  oauthTokenHeader: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/widgets/${siteUid}/`,
    oauthTokenHeader
  );
}
async function getPageUrlContent(siteUrl: string | null | undefined) {
  while (!siteUrl) {
    await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 100ms before checking again
  }

  let randomNumber: number = getRandomTwoDigitNumber();
  return fetchWrapper.getUrl(
    `${apiUrl}/utilities/fetch_page_source/?url=${encodeURIComponent(
      `${siteUrl}?remove_lazy=1&v=1&id=${randomNumber}&source=aladdin_ui`
    )}`
  );
}

function updatePage(
  data: any,
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    data,
    oauthTokenHeader
  );
}

function getPageUrlContentPreviewPage(siteUrl: string) {
  return fetchWrapper.getUrl(
    `${apiUrl}/utilities/fetch_page_source/?url=${encodeURIComponent(
      `${siteUrl}&source=aladdin_ui`
    )}`
  );
}

function getPagePreviewForCurrentChanges(
  siteUid: string,
  pageUid: string,
  data: any,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/?preview=1/`,
    data,
    oauthTokenHeader
  );
}

function deletePage(
  siteUid: string,
  page_shared_uid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.delete(
    `${apiUrl}/asset_management/pages/${siteUid}/${page_shared_uid}/?delete=1`,
    oauthTokenHeader
  );
}

function imageUpload(siteUid: string, oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/images/${siteUid}/`,
    data,
    oauthTokenHeader
  );
}
function discardPage(
  data: any,
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/?discard=1`,
    data,
    oauthTokenHeader
  );
}

function savePage(
  data: any,
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    data,
    oauthTokenHeader
  );
}

export const pageBuildingService = {
  getPageContent,
  getSiteCurrentWidgets,
  getSiteAllAvailableWidgets,
  getPageUrlContent,
  updatePage,
  getPageUrlContentPreviewPage,
  getPagePreviewForCurrentChanges,
  deletePage,
  imageUpload,
  discardPage,
  savePage,
};
